export const SsnFormField = {
  ssn: 'ssn',
} as const;

export const PinFormField = {
  pin: 'pin',
} as const;

export const EmployeeBasicInfoFormField = {
  ssn: 'ssn',
  firstName: 'firstName',
  lastName: 'lastName',
  phoneNumber: 'phoneNumber',
  email: 'email',
  password: 'password',
  confirmPassword: 'confirmPassword',
  homeAddress: 'homeAddress',
} as const;

export const FORM_ERROR_KEY = {
  PIN_NOT_FOUND: 'PIN_NOT_FOUND',
  SSN_NOT_FOUND: 'SSN_NOT_FOUND',
} as const;
